import { initialize, change } from 'redux-form';

import { success, loading, handleErrorException } from 'State/actions';
import { EXPORT_TOTALS_FORM_NAME } from 'Common/FormEnum';
import { ExportTotalsFieldEnum } from 'Common/FieldEnum';

import * as Helpers from '../helpers/exporttotals';
import * as types from './types';

export const getPage = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EXPORT_TOTALS_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `ExportTotals/GetExportTotalsPage`
      );
      const result = response.data.Data;
      const defaultValues = Helpers.getDefaultValues(result);
      dispatch(initialize(EXPORT_TOTALS_FORM_NAME, defaultValues));
      dispatch(success(types.EXPORT_TOTALS_FETCH_SUCCESS, result));
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.EXPORT_TOTALS_FETCH_ERROR, {
          Title: 'Error',
          Message: 'Could not retrieve page.',
        })
      );
    } finally {
      dispatch(loading(types.EXPORT_TOTALS_FETCHING, false));
    }
  };
};

export const exportData = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EXPORT_TOTALS_FETCHING, true));
    try {
      const hasReport = await MPWWebApi.postDownloadFile(
        `ExportTotals/WriteExportTotals`,
        Helpers.formatFileName(data),
        data
      );
      dispatch(setHasReport(hasReport));
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.EXPORT_TOTALS_FETCH_ERROR, {
          Title: 'Error',
          Message: 'Could not export data.',
        })
      );
    } finally {
      dispatch(loading(types.EXPORT_TOTALS_FETCHING, false));
    }
  };
};

export const clearErrors = () => {
  return {
    type: types.EXPORT_TOTALS_CLEAR_ERRORS,
  };
};

export const setExportType = exportType => {
  return change(
    EXPORT_TOTALS_FORM_NAME,
    ExportTotalsFieldEnum.ExportType,
    exportType
  );
};

export const setSelectedSiteIds = siteIds => {
  return change(
    EXPORT_TOTALS_FORM_NAME,
    ExportTotalsFieldEnum.SelectedSiteIds,
    siteIds
  );
};

export const setHasReport = hasReport => {
  return {
    type: types.EXPORT_TOTALS_SET_HAS_REPORT,
    payload: hasReport,
  };
};



// WEBPACK FOOTER //
// ./src/pages/exporttotals/state/actions.js